/**
 * Shared utility functions and constants for YouTube components.
 */

export const YOUTUBE_CHANNEL_NAME = 'Mermaids Of The Moment';
export const YOUTUBE_CHANNEL_URL =
  'https://www.youtube.com/@mermaidsofthemoment';

/** Format a numeric view/like count string into a compact form (e.g. 1.2M, 3.5K). */
export function formatViewCount(count: string): string {
  const num = parseInt(count);
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  } else if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  return count;
}

/** Truncate a plain string to `maxLength` characters, appending "..." if needed. */
export function truncateTitle(title: string, maxLength: number = 60): string {
  return title.length > maxLength
    ? title.substring(0, maxLength) + '...'
    : title;
}

/** Strip HTML tags from a string. */
export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, '');
}

/** Strip HTML then truncate to `max` characters. */
export function truncate(text: string, max: number): string {
  const clean = stripHtml(text);
  if (clean.length <= max) return clean;
  return clean.slice(0, max).trimEnd() + '...';
}

/** Fisher-Yates shuffle, returning a new array. */
export function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

/** Shuffle then pick the first `count` items. */
export function shuffleAndPick<T>(arr: T[], count: number): T[] {
  return shuffleArray(arr).slice(0, count);
}

/** Regex pattern for a valid 11-character YouTube video ID. */
export const YOUTUBE_VIDEO_ID_REGEX = /^[a-zA-Z0-9_-]{11}$/;

/** Validate whether a string is a valid YouTube video ID. */
export function isValidYouTubeVideoId(id: string): boolean {
  return YOUTUBE_VIDEO_ID_REGEX.test(id);
}
